export const invariant: (predicate: unknown, message?: string) => asserts predicate = (
    predicate,
    message,
) => {
    if (!predicate) {
        throw new Error(message || 'Invariant violation')
    }
}
